export default __webpack_public_path__ + "static/media/Footer4_white_en.9560f57f.png";